import { GoogleAuthProvider } from "firebase/auth";

export const provider = new GoogleAuthProvider();
